import { QueryType } from '@/app/types/types'
import { apiClient } from '..'

const getAllCandidatesRequest = async (params: QueryType) => {
    return apiClient().get('/api/candidates', { params })
}

const getOneCandidateRequest = async (id: number, params: QueryType) => {
    return apiClient().get(`/api/candidates/${id}`, { params })
}

const processCandidatesRequest = async (data: QueryType) => {
    return apiClient().post('/api/candidates/process', data)
}

const updateCandidateRequest = async (id: number, data: QueryType) => {
    return apiClient().put(`/api/candidates/${id}`, data)
}

const deleteCandidateRequest = async (id: number, data: QueryType = {}) => {
    return apiClient().delete(`/api/candidates/${id}`, { params: data })
}

export { getAllCandidatesRequest, getOneCandidateRequest, processCandidatesRequest, updateCandidateRequest, deleteCandidateRequest }
